import { RoleNavigationService } from 'cw-services';
import { FuseNavigation } from './../../types/fuse-navigation';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

@Component({
    selector: 'fuse-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FuseNavigationComponent implements OnInit, OnDestroy {
    @Input()
    layout = 'horizontal';

    @Input()
    navigation: FuseNavigation[];

    // Private
    private _unsubscribeAll: Subject<any>;
    private _closeTimeout: ReturnType<typeof setTimeout> | null = null;

    /**
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {FuseNavigationService} _fuseNavigationService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private roleNavigationService: RoleNavigationService,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Load the navigation either from the input or from the service
        this.navigation = this.navigation || this._fuseNavigationService.getCurrentNavigation();

        // Subscribe to the current navigation changes
        this._fuseNavigationService.onNavigationChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res) => {
                // Load the navigation
                this.navigation = this._fuseNavigationService.getCurrentNavigation();

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        // Subscribe to navigation item
        merge(
            this._fuseNavigationService.onNavigationChanged,
            this._fuseNavigationService.onNavigationItemAdded,
            this._fuseNavigationService.onNavigationItemUpdated,
            this._fuseNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res) => {
                // Mark for check
                this._changeDetectorRef.markForCheck();

            });
    }

    ngOnDestroy() {
        this.clearCloseTimeout();
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    @HostListener('mouseenter')
    onMouseEnter(): void {
        this.clearCloseTimeout();
    }

    @HostListener('mouseleave')
    onMouseLeave(): void {
        if (this.layout !== 'horizontal') {
            return;
        }

        this.clearCloseTimeout();
        this._closeTimeout = setTimeout(() => {
            this._closeTimeout = null;
            this._fuseNavigationService.onItemCollapsed.next(null);
            this._changeDetectorRef.markForCheck();
        }, 1000);
    }

    private clearCloseTimeout(): void {
        if (this._closeTimeout !== null) {
            clearTimeout(this._closeTimeout);
            this._closeTimeout = null;
        }
    }
}
